import { IRootState } from '../../../store'
import { IFactorsAffectingCareOptionsState } from '../store/options.types'

export const getFactorsAffectingCareOptionsSelector = (state: IRootState): IFactorsAffectingCareOptionsState =>
  state.options.factorsAffectingCareOptions
